import * as React from 'react';
import { createTheme } from '@mui/material/styles';
import { font_Family } from 'appConfig';

export const theme = createTheme({
    typography: {
        fontFamily: font_Family,
    },
});
